import { render, staticRenderFns } from "./MapLoader.vue?vue&type=template&id=670ea506&scoped=true"
import script from "./MapLoader.vue?vue&type=script&lang=ts"
export * from "./MapLoader.vue?vue&type=script&lang=ts"
import style0 from "./MapLoader.vue?vue&type=style&index=0&id=670ea506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ea506",
  null
  
)

export default component.exports